import { AxiosError } from 'axios';
import {
  msPlanInterface,
  msplansalesSummaryInterface,
  notesInterface,
  salesplanconceptInstanceInterface,
  salesplanEditInterface,
  salesplansalesSummaryInterface,
  salesPlanStatusInterface,
  salesPlanView,
  singleConceptInterface,
  singleContractInterface,
  tmsEditScreenDataInterface,
  tmsViewDataInterface,
} from 'Interfaces/FDPInterfaces/tmsInterfaces';
import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { tmsScreenServices } from 'services/tmsScreenServices';
import {
  convertSalesPlanPlanningPeriodArray,
  convertSalesPlanPlanningPeriodLabelArray,
  getCurrentMonthDate,
} from 'utils/dateUtilities';
import { deepCopy } from 'utils/deepCopy';
import { CommonStore } from './CommonStore';

export class MSPlanStore {
  commonStore: CommonStore;
  tmsViewMode: boolean = true;
  isSalesDetailsLoading: boolean = false;
  isAllConceptLoading: boolean = false;
  tabIndex: boolean = true;
  allDrugMoleculesDetailsForSearch: salesplanconceptInstanceInterface[] = [];
  filteredDrugMoleculesDetails: salesplanconceptInstanceInterface[] = [];
  TMSsalesSummaryData: msplansalesSummaryInterface[] | undefined = [];
  SalesPlansalesSummaryData: salesplansalesSummaryInterface[] | undefined = [];
  conceptSearchInput: string = '';
  filteredConceptsForSearch: string[] = [];
  isConceptLoading: boolean = false;
  summaryVisibility: boolean = false;
  conceptDetails: singleConceptInterface | null = {
    concept: '',
    gfc: 0,
    generic_rxcui: '',
    therapeutic_category: '',
    pharmacologic_class: '',
    va_class_name: '',
    des_schedule: '',
    duration_condition: '',
    Strength: '',
  };
  contractDetails: singleContractInterface[] | [] = [
    {
      GFC: 0,
      ContractNumber: '',
      ContractType: '',
      StartDate: '',
      EndDate: '',
    },
  ];
  isConceptDetailsLoading: boolean = false;
  istmsPlanDataDirectLoading: boolean = false;
  isTMSPlanViewDataLoading: boolean = false;

  tmsEditData: tmsEditScreenDataInterface = [];
  oldtmsEditData: tmsEditScreenDataInterface = [];
  oldTmsData: msPlanInterface = [];
  msplandirectmode: boolean = true;
  msplanindirectmode: boolean = true;
  tmsViewData: tmsViewDataInterface = {
    GFC: 0,
    tms_adjustment_data: [
      {
        COT: '',
        SellingCategories: [
          {
            SellingCategory: '',
            tms_adjustment_details: [
              {
                TMSPlanningMonth: '',
                TMSStrategyCode: '',
                TargetMarketShare: 0,
                Adjustment: 0,
                MarketSharePlan: 0,
              },
            ],
          },
        ],
      },
    ],
  };
  salesplanViewData: salesPlanView = {
    GFC: 0,
    sales_plan_data: [
      {
        COT: '',
        SellingCategories: [
          {
            SellingCategory: '',
            sales_plan_details: [
              {
                Adjustment: 0,
                SalesPlan: 0,
                Month: '',
                Note: '',
                MarketSalesForecast: 0,
                TargetMarketShare: 0,
                MarketSharePlan: 0,
              },
            ],
          },
        ],
      },
    ],
  };
  salesplanEditData: salesplanEditInterface[] = [];
  oldsalesplanEditData: salesplanEditInterface[] = [];
  istmsUpdateLoading: boolean = false;
  percentProgress: { percentage: number } = { percentage: 0 };
  // salesplanstatus: salesPlanStatusInterface = {
  //   GFC: 0,
  //   MarketShareAdjustmentStatus: false,
  //   SalesPlanAdjustmentStatus: false,
  // };
  isSalesPlanStatusLoading: boolean = false;
  isBulkUpdateModalOpen: boolean = false;
  isbulkMSPlanupdateGFCLoading: boolean = false;
  bulkMSPlanupdateGFC: {
    Status: string;
    Concept_info: {
      GFC: number;
      Concept: string;
    }[];
  }[] = [];

  bulkUpdateDirectTodoGFC: {
    GFC: number;
    Concept: string;
  }[] = [];
  bulkUpdateIndirectTodoGFC: {
    GFC: number;
    Concept: string;
  }[] = [];

  bulkUpdateDirectCompletedGFC: {
    GFC: number;
    Concept: string;
  }[] = [];
  bulkUpdateIndirectCompletedGFC: {
    GFC: number;
    Concept: string;
  }[] = [];

  bulkUpdateGFCs: number[] = [];
  isTMSNotesDataLoading: boolean = false;
  tmsNotesData: notesInterface[] = [];
  isMSplanNoteSaving: boolean = false;
  isMSplanNoteSaved: boolean = false;
  isSalesplanNoteSaved: boolean = false;
  isSalesPlanPercentLoading: boolean = false;
  isMSplanPlanningPeriodLoading: boolean = false;
  isSalesplanPlanningPeriodLoading: boolean = false;
  msplanPlanningPeriod: { label: string; code: string }[] = [];
  salesplanPlanningPeriod: { label: string; code: string }[] = [];
  msplanPeriod: { label: string; code: string } = { label: '', code: '' };
  salesPlanPeriod: { label: string; code: string } = { label: '', code: '' };
  tmsSaveError: boolean = false;
  salesPlanError: boolean = false;

  // sales plan
  isSalesPlanDataLoading: boolean = false;
  isNewSalesPlanData: boolean = false;
  isSalesPlanUpdating: boolean = false;
  isSalesPlanEditDataLoading: boolean = false;
  cotsWithNullOldData: Set<string> = new Set();

  // bulk update variables
  isMSPlanbulkUpdating: boolean = false;
  msPlanStatusCheck: boolean = false;
  salesPlanStatusCheck: boolean = false;
  planBtnLabel: string = '';

  constructor(commonStore: CommonStore) {
    makeAutoObservable(this);
    this.commonStore = commonStore;
  }

  updateOldMSValues = () => {
    this.oldtmsEditData = deepCopy(this.tmsEditData);
  };

  updteOldSPValues = () => {
    this.oldsalesplanEditData = deepCopy(this.salesplanEditData);
  };

  setTabIndex = () => {
    this.tabIndex = !this.tabIndex;
  };

  // Filter function with custom debounce
  private debounceTimer: ReturnType<typeof setTimeout> | null = null;

  handleFetchAllDetailsByGFC = async (gfc: string) => {
    this.isAllConceptLoading = true;
    try {
      // const data = await tmsScreenServices.getAllGSMSConceptForSalesPlan();
      this.fetchSalesProgress();
      const data = await tmsScreenServices.getAllGSMSConceptForSalesPlan();
      this.fetchMSPlanBulkUpdategfcs();

      runInAction(() => {
        this.allDrugMoleculesDetailsForSearch = data;
        this.filteredDrugMoleculesDetails = data;
      });

      const [moleculeForGfcParam] = this.allDrugMoleculesDetailsForSearch.filter(
        drug => drug.gfc === parseInt(gfc)
      );
      if (moleculeForGfcParam) {
        this.conceptSearchInput = moleculeForGfcParam.concept;
        this.handleSearch();
      } else {
        toast.error(`There is no molecule corresponding to gfc - ${gfc}`);
      }
    } catch (err) {
      console.error('Error while getting all drug details:', err);
    } finally {
      runInAction(() => {
        this.isAllConceptLoading = false;
      });
    }
  };

  // fetch all the concept and the sales plan progress
  handleFetchAllConceptDetailsForSearch = async () => {
    this.isAllConceptLoading = true;
    try {
      this.fetchSalesProgress();
      const data = await tmsScreenServices.getAllGSMSConceptForSalesPlan();
      this.fetchMSPlanBulkUpdategfcs();

      runInAction(() => {
        this.allDrugMoleculesDetailsForSearch = data;
        this.filteredDrugMoleculesDetails = data;
      });
    } catch (err) {
      console.error('Error while getting all drug details:', err);
    } finally {
      runInAction(() => {
        this.isAllConceptLoading = false;
      });
    }
  };

  private debounce(func: (...args: any[]) => void, delay: number) {
    return (...args: any[]) => {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  // filter the concepts as the user types in the searchbar
  handleFilterConceptSearch = this.debounce(() => {
    if (!this.conceptSearchInput.trim()) {
      this.filteredConceptsForSearch = [];
      return;
    }

    const searchText = this.conceptSearchInput.toLowerCase();
    runInAction(() => {
      this.filteredConceptsForSearch = this.allDrugMoleculesDetailsForSearch
        .filter(concept => concept.concept.toLowerCase().includes(searchText))
        .slice(0, 10)
        .map(concept => concept.concept); // Extract only the `concept` string

      // Auto-select if only one result matches
      if (this.filteredConceptsForSearch.length === 1) {
        const _selectedConcept = this.allDrugMoleculesDetailsForSearch.find(
          item => item.concept === this.filteredConceptsForSearch[0]
        );
      }
    });
  }, 300);

  handleConceptSearchInputChange = (input: string) => {
    this.conceptSearchInput = input;
    this.handleFilterConceptSearch();
  };

  getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    return `${year}-${month}-01`;
  };

  handleGetConceptDetails = async (gfc_id: number) => {
    if (this.isConceptLoading) {
      return;
    }
    runInAction(() => {
      this.isConceptLoading = true;
      this.isSalesDetailsLoading = true;
      this.isTMSPlanViewDataLoading = true;
      this.isSalesPlanDataLoading = true;
      this.isTMSNotesDataLoading = true;
      this.isSalesPlanStatusLoading = true;
    });
    try {
      const data = await tmsScreenServices.getSingleGSMSConcept(gfc_id);
      runInAction(() => {
        this.conceptDetails = data.concept_info[0];
        this.contractDetails = data.contract_info;
      });
      this.isConceptLoading = false;

      if (this.conceptDetails?.gfc) {
        this.fetchSalesPlanStatus(gfc_id);
        this.fetchMSplanPlanningPeriod(gfc_id);
        this.fetchSalesPlanPlanningPeriod(gfc_id);
        this.fetchMSGFCNotes(this.conceptDetails.gfc);
        this.fetchSalesDetails(gfc_id, 'Share');
        this.fetchSalesDetails(gfc_id, 'Volume');
      }
    } catch (error) {
      console.error('Error while getting concept details:', error);
    } finally {
      this.isConceptLoading = false;
    }
  };

  getTargetMarketScreenData = async () => {
    if (
      this.isConceptLoading ||
      this.isSalesDetailsLoading ||
      this.isTMSPlanViewDataLoading ||
      this.isSalesPlanDataLoading ||
      this.isTMSNotesDataLoading
    ) {
      return;
    }
    try {
      runInAction(() => {
        this.isTMSPlanViewDataLoading = true;
        this.isSalesPlanDataLoading = true;
        this.isSalesPlanStatusLoading = true;
        this.isMSplanPlanningPeriodLoading = true;
        this.isSalesplanPlanningPeriodLoading = true;
        this.isSalesDetailsLoading = true;
      });

      if (this.conceptDetails?.gfc) {
        this.fetchSalesPlanStatus(this.conceptDetails.gfc);
        this.fetchMSplanPlanningPeriod(this.conceptDetails?.gfc);
        this.fetchSalesPlanPlanningPeriod(this.conceptDetails?.gfc);
        this.fetchSalesDetails(this.conceptDetails?.gfc, 'Share');
        this.fetchSalesDetails(this.conceptDetails?.gfc, 'Volume');
      }
    } catch (error) {
      console.error('Error while getting concept details:', error);
    }
  };

  handleSearch = async () => {
    if (this.isConceptDetailsLoading) {
      return;
    }

    if (!this.conceptSearchInput) return;

    const matchedMolecules = this.allDrugMoleculesDetailsForSearch.filter(
      concept => concept.concept === this.conceptSearchInput
    );

    if (matchedMolecules.length === 0) {
      toast.error('No concept found with provided name');
    }

    const currURL = window.location.href;
    const url_check = currURL.includes('edit');
    if (url_check) {
      window.location.href = `/fdp/target_market?gfc=${matchedMolecules[0].gfc}`;
    }

    if (matchedMolecules.length > 0) {
      const selectedConcept = matchedMolecules[0];
      this.handleGetConceptDetails(selectedConcept.gfc);
    } else {
      // this.isConceptDetailsLoading = false;
    }
  };

  handleEnterKeyDownConceptSearchField = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      this.handleSearch();
    }
  };

  fetchMSplanPlanningPeriod = async (gfc: number) => {
    this.tabIndex = true;
    try {
      const data = await tmsScreenServices.getMSplanPlanningPeriods(gfc);
      this.msplanPlanningPeriod = convertSalesPlanPlanningPeriodArray(data.reverse());
      if (this.msplanPlanningPeriod.length > 0) {
        this.msplanPeriod = this.msplanPlanningPeriod[0];
        this.getTMSplanViewData(this.msplanPlanningPeriod[0].code, gfc);
      } else {
        this.isTMSPlanViewDataLoading = false;
      }
    } catch (error) {
      console.log('MSPlanstore => fetchMSplanPlanningPeriod => ', error);
    } finally {
      this.isMSplanPlanningPeriodLoading = false;
    }
  };

  fetchSalesPlanPlanningPeriod = async (gfc: number) => {
    try {
      const res = await tmsScreenServices.getSalesplanPlanningPeriods(gfc);
      // Sort planning periods in descending order
      const sortedPlanningPeriods = [...res].sort((a, b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateB.getTime() - dateA.getTime();
      });
      this.salesplanPlanningPeriod = convertSalesPlanPlanningPeriodLabelArray(sortedPlanningPeriods);
      if (this.salesplanPlanningPeriod.length > 0) {
        this.salesPlanPeriod = this.salesplanPlanningPeriod[0];
        this.fetchSalesPlanData(this.salesPlanPeriod.code, gfc);
      } else {
        this.isSalesPlanDataLoading = false;
      }
    } catch (error) {
      console.log('MSPlanstore => fetchSalesPlanPlanningPeriod => ', error);
    } finally {
      this.isSalesplanPlanningPeriodLoading = false;
    }
  };

  setMSplanPlaningPeriod = (period: { label: string; code: string }) => {
    this.msplanPeriod = period;
    if (this.conceptDetails) {
      this.getTMSplanViewData(period.code, this.conceptDetails?.gfc);
    }
  };

  setSalesplanPlaningPeriod = (period: { label: string; code: string }) => {
    this.salesPlanPeriod = period;
    if (this.conceptDetails) {
      this.fetchSalesPlanData(period.code, this.conceptDetails?.gfc);
    }
  };

  fetchMSGFCNotes = async (gfc: number, signal: AbortController['signal'] | null = null) => {
    console.log('fetching the notes data');
    try {
      this.isTMSNotesDataLoading = true;
      this.tmsNotesData = await tmsScreenServices.getGFCNotes(gfc, 'sales plan', signal);
    } catch (error) {
      console.log('MSPlanStore fetchMSGFCNotes => ', error);
    } finally {
      this.isTMSNotesDataLoading = false;
    }
  };

  setNoteData = (idx: number, note: string) => {
    this.tmsNotesData[idx].Notes = note;
  };

  removeNoteData = (idx: number) => {
    this.tmsNotesData.splice(idx, 1);
  };

  fetchMSPlanBulkUpdategfcs = async () => {
    this.isbulkMSPlanupdateGFCLoading = true;
    try {
      const data = await tmsScreenServices.getGfcBulkPlanList();

      this.bulkUpdateDirectTodoGFC = data.plan_status.Direct.ToDo;
      this.bulkUpdateDirectCompletedGFC = data.plan_status.Direct.Completed;
      this.bulkUpdateIndirectTodoGFC = data.plan_status.Indirect.ToDo;
      this.bulkUpdateIndirectCompletedGFC = data.plan_status.Indirect.Completed;

      // this.bulkMSPlanupdateGFC = data.plan_status;
      // const todolist = this.bulkMSPlanupdateGFC.filter(
      //   (item) => item.Status === "todo"
      // );
      // const completedlist = this.bulkMSPlanupdateGFC.filter(
      //   (item) => item.Status.toLowerCase() === "completed"
      // );
      // this.bulkUpdateTodoGFC = todolist[0]?.Concept_info.map((item) => ({
      //   ...item,
      //   selected: false,
      // }));
      // this.bulkUpdateCompletedGFC = completedlist[0]?.Concept_info.map(
      //   (item) => ({ ...item, selected: false })
      // );
    } catch (error) {
      console.log('MSPlanStore fetchMSPlanBulkUpdategfcs => ', error);
    } finally {
      this.isbulkMSPlanupdateGFCLoading = false;
      this.isSalesPlanPercentLoading = false;
    }
  };

  fetchSalesProgress = async () => {
    this.isSalesPlanPercentLoading = true;
    try {
      const data = await tmsScreenServices.getSalesPlanProgress();
      this.percentProgress = data;
    } catch (error) {
      console.log('MSPlanStore fetchSalesProgress => ', error);
    }
  };

  determinePlanStatus = (data: salesPlanStatusInterface) => {
    if (Object.keys(data.ms_plan).length === 0 && Object.keys(data.sales_plan).length === 0) {
      return 'New plan';
    }

    const msValues = Object.values(data.ms_plan);
    const salesValues = Object.values(data.sales_plan);

    const anyTrue =
      msValues.some(value => value === true) || salesValues.some(value => value === true);
    const allTrue =
      msValues.every(value => value === true) && salesValues.every(value => value === true);
    const allFalse =
      msValues.every(value => value === false) && salesValues.every(value => value === false);

    if (allTrue) {
      return 'Edit plan';
    } else if (anyTrue) {
      return 'Continue plan';
    } else if (allFalse) {
      return 'New plan';
    }
    return '';
  };

  fetchSalesPlanStatus = async (gfc: number) => {
    this.isSalesPlanStatusLoading = true;

    try {
      const planning_period = this.getCurrentDate();
      const data = await tmsScreenServices.getSalesPlanStatus(planning_period, gfc);
      this.planBtnLabel = this.determinePlanStatus(data);
    } catch (error) {
      console.log('MSPlanStore fetchSalesPlanStatus => ', error);
    } finally {
      this.isSalesPlanStatusLoading = false;
    }
  };

  fetchSalesDetails = async (gfc: number, category: string) => {
    try {
      if (category === 'Share') {
        const data = await this.commonStore.fetchMSSalesSummaryData(gfc);
        this.TMSsalesSummaryData = data;
      } else {
        const data = await this.commonStore.fetchSalesPlanSalesSummaryData(gfc);
        this.SalesPlansalesSummaryData = data;
      }
    } catch (error) {
      console.log('MSPlanStore fetchSalesSummaryData => ', error);
    } finally {
      this.isSalesDetailsLoading = false;
    }
  };

  getTMSplanViewData = async (planning_period: string, gfc: number) => {
    this.tmsEditData = [];
    this.oldTmsData = [];
    try {
      this.isTMSPlanViewDataLoading = true;
      this.tmsViewData = await tmsScreenServices.getTMSAdjustments(planning_period, gfc);
    } catch (error) {
      console.error('An error occurred in getTMSplanViewData:', error);
    } finally {
      this.isTMSPlanViewDataLoading = false;
    }
  };

  // get tms data for the edit screen
  getTMSplanData = async (gfc: number, signal: AbortController['signal'] | null = null) => {
    this.istmsPlanDataDirectLoading = true;

    try {
      const planning_period = getCurrentMonthDate();
      const data = await tmsScreenServices.getTmsEditScreenData(gfc, planning_period, signal);
      this.tmsEditData = data;
      this.oldtmsEditData = data;
      if (this.msPlanStatusCheck) {
        this.fetchSalesPlanEditData(planning_period, gfc);
      }
    } catch (err) {
      console.error('An error occurred in getTMSplanData:', err);
      this.istmsPlanDataDirectLoading = false; // Turn off the loader
    } finally {
      this.istmsPlanDataDirectLoading = false; // Turn off the loader
    }
  };

  saveTMSData = async (
    payload: {
      MarketShareID: number;
      TMSPlanningMonth: string;
      Adjustment: number;
      MarketSharePlan: number;
      Note: string;
      PlanningPeriod: string;
    }[]
  ) => {
    this.istmsUpdateLoading = true;
    this.tmsSaveError = false;
    try {
      await tmsScreenServices.updateTMSData(payload);
      this.isMSplanNoteSaved = false;
    } catch (error) {
      console.log('Error saving TMS data=> ', error);
      this.tmsSaveError = true;
      toast.error(String(error));
    } finally {
      this.istmsUpdateLoading = false;
      if (this.conceptDetails !== null) {
        this.fetchSalesPlanEditData(getCurrentMonthDate(), this.conceptDetails?.gfc);
      }
    }
  };

  savePlanNote = async (gfc: number, note: string, planning_type: string, screen: string) => {
    this.isMSplanNoteSaving = true;
    let data: notesInterface[] = [];
    try {
      const payload = {
        gfc: gfc,
        note: note,
        planning_type: planning_type,
      };
      data = await tmsScreenServices.saveGFCNote(payload);

      if (data.length > 0) {
        if (screen === 'msplan') {
          this.isMSplanNoteSaved = true;
        } else if (screen === 'salesplan') {
          this.isSalesplanNoteSaved = true;
        }
      }
    } catch (error) {
      console.log('Error saving Note=> ', error);
    } finally {
      this.tmsNotesData = data;
      this.isMSplanNoteSaving = false;
    }
  };

  fetchSalesPlanData = async (planning_period: string, gfc: number) => {
    try {
      this.isSalesPlanDataLoading = true;
      this.salesplanViewData = await tmsScreenServices.getConceptSalesPlan(planning_period, gfc);
    } catch (err) {
      console.error('An error occurred in fetchSalesPlanData:', err);
    } finally {
      console.log('finally block for fetching the sales plan');
      this.isSalesPlanDataLoading = false;
    }
  };

  fetchSalesPlanEditData = async (planning_period: string, gfc: number) => {
    this.salesplanEditData = [];
    this.isSalesPlanEditDataLoading = true;
    try {
      // getting the salesplan data for the edit screen
      if (this.istmsUpdateLoading || this.salesplanEditData.length === 0) {
        const data = await tmsScreenServices.getConceptSalesPlanEditData(planning_period, gfc);
        this.salesplanEditData = data;
        this.oldsalesplanEditData = data;
      }
    } catch (error) {
      console.log('fetchSalesPlanEditData=> ', error);
    } finally {
      this.istmsUpdateLoading = false;
      this.isSalesPlanEditDataLoading = false;
    }
  };

  fetchNewSalesPlanData = async (planning_period: string, gfc: number) => {
    this.isNewSalesPlanData = true;
    try {
      await this.getTMSplanViewData(planning_period, gfc);
    } catch (error) {
      console.log('fetchNewSalesPlanData=> ', error);
    } finally {
      this.isNewSalesPlanData = false;
    }
  };

  saveSalesPlanData = async (
    payload: {
      MarketShareAdjustment: number;
      Month: string;
      Adjustment: number;
      SalesPlan: number;
      Note: string;
      PlanningPeriod: string;
      MarketSalesForecast: string;
    }[]
  ) => {
    this.isSalesPlanUpdating = true;
    this.salesPlanError = false;
    try {
      await tmsScreenServices.updateSalesPlanData(payload);
      this.isSalesplanNoteSaved = false;
    } catch (error) {
      console.log('saveSalesPlanData=> ', error);
      this.salesPlanError = true;
      if (error instanceof AxiosError) {
        if (error.response && error.response.data) {
          toast.error(error?.response?.data?.error);
        }
      }
    } finally {
      this.isSalesPlanUpdating = false;
    }
  };

  bulkUpdateMSPlan = async (
    gfc_list: number[],
    selling_category: string,
    planning_period: string
  ) => {
    this.isMSPlanbulkUpdating = true;
    try {
      const payload: {
        gfc_list: number[];
        planning_period: string;
        user: string;
        SellingCategory: string;
      } = {
        gfc_list: gfc_list,
        planning_period: planning_period,
        user: 'frontend user',
        SellingCategory: selling_category,
      };
      await tmsScreenServices.bulkUpdateMSplan(payload);
      this.isBulkUpdateModalOpen = false;
    } catch (error) {
      console.log('bulkUpdateMSPlan=> ', error);
    } finally {
      this.fetchSalesProgress();
      this.fetchMSPlanBulkUpdategfcs();
      this.isMSPlanbulkUpdating = false;
      // this.isBulkUpdateModalOpen = false;
    }
  };

  toggleSummaryModalVisibility = () => {
    this.summaryVisibility = !this.summaryVisibility;
  };

  toggleBulkUpdateModal = () => {
    this.isBulkUpdateModalOpen = !this.isBulkUpdateModalOpen;
  };

  toggleMSplandirectmode = () => {
    this.msplandirectmode = !this.msplandirectmode;
  };

  toggleMSplanindirectmode = () => {
    this.msplanindirectmode = !this.msplanindirectmode;
  };

  handleSetOldTmsEditData = (data: tmsEditScreenDataInterface) => {
    this.oldtmsEditData = data;
  };

  resetStore = () => {
    // Generic store state
    this.tmsViewMode = true;
    this.isSalesDetailsLoading = false;
    this.isAllConceptLoading = false;
    this.tabIndex = true;

    // Search related observables
    this.allDrugMoleculesDetailsForSearch = [];
    this.filteredDrugMoleculesDetails = [];
    this.conceptSearchInput = '';
    this.filteredConceptsForSearch = [];
    this.isConceptLoading = false;

    // Modal visibility
    this.summaryVisibility = false;
    this.isBulkUpdateModalOpen = false;

    // Concept and Contract details
    this.conceptDetails = {
      concept: '',
      gfc: 0,
      generic_rxcui: '',
      therapeutic_category: '',
      pharmacologic_class: '',
      va_class_name: '',
      des_schedule: '',
      duration_condition: '',
      Strength: '',
    };
    this.contractDetails = [
      {
        GFC: 0,
        ContractNumber: '',
        ContractType: '',
        StartDate: '',
        EndDate: '',
      },
    ];
    this.isConceptDetailsLoading = false;

    // Loading states
    this.istmsPlanDataDirectLoading = false;
    this.isTMSPlanViewDataLoading = false;
    this.istmsUpdateLoading = false;
    this.isSalesPlanStatusLoading = false;
    this.isTMSNotesDataLoading = false;
    this.isMSplanNoteSaving = false;
    this.isSalesPlanPercentLoading = false;
    this.isMSplanPlanningPeriodLoading = false;
    this.isSalesplanPlanningPeriodLoading = false;
    this.isbulkMSPlanupdateGFCLoading = false;
    this.isSalesPlanDataLoading = false;
    this.isNewSalesPlanData = false;
    this.isSalesPlanUpdating = false;
    this.isSalesPlanEditDataLoading = false;
    this.isMSPlanbulkUpdating = false;

    // TMS and Sales Plan data
    this.tmsEditData = [];
    this.oldtmsEditData = [];
    this.oldTmsData = [];
    this.TMSsalesSummaryData = [];
    this.SalesPlansalesSummaryData = [];
    this.salesplanEditData = [];
    this.oldsalesplanEditData = [];
    this.tmsNotesData = [];

    // Mode settings
    this.msplandirectmode = true;
    this.msplanindirectmode = true;

    // Planning periods
    this.msplanPlanningPeriod = [];
    this.salesplanPlanningPeriod = [];
    this.msplanPeriod = { label: '', code: '' };
    this.salesPlanPeriod = { label: '', code: '' };

    // Bulk update data
    this.bulkMSPlanupdateGFC = [];
    this.bulkUpdateDirectTodoGFC = [];
    this.bulkUpdateIndirectTodoGFC = [];
    this.bulkUpdateDirectCompletedGFC = [];
    this.bulkUpdateIndirectCompletedGFC = [];
    this.bulkUpdateGFCs = [];

    // Status flags
    this.isMSplanNoteSaved = false;
    this.isSalesplanNoteSaved = false;
    this.tmsSaveError = false;
    this.salesPlanError = false;
    this.msPlanStatusCheck = false;
    this.salesPlanStatusCheck = false;
    this.planBtnLabel = '';
    this.percentProgress = { percentage: 0 };
    this.cotsWithNullOldData = new Set();

    // Reset view data to default state
    this.tmsViewData = {
      GFC: 0,
      tms_adjustment_data: [
        {
          COT: '',
          SellingCategories: [
            {
              SellingCategory: '',
              tms_adjustment_details: [
                {
                  TMSPlanningMonth: '',
                  TMSStrategyCode: '',
                  TargetMarketShare: 0,
                  Adjustment: 0,
                  MarketSharePlan: 0,
                },
              ],
            },
          ],
        },
      ],
    };

    this.salesplanViewData = {
      GFC: 0,
      sales_plan_data: [
        {
          COT: '',
          SellingCategories: [
            {
              SellingCategory: '',
              sales_plan_details: [
                {
                  Adjustment: 0,
                  SalesPlan: 0,
                  Month: '',
                  Note: '',
                  MarketSalesForecast: 0,
                  TargetMarketShare: 0,
                  MarketSharePlan: 0,
                },
              ],
            },
          ],
        },
      ],
    };
  };
}
